import axios from "axios";
import Config from "src/config";

const actionListaNotificacoes = usuarioId => {
    return axios({
        method: "get",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v1/notificacoes/${usuarioId}/lista`
    });
};

export default actionListaNotificacoes;
